import React, { useState, useEffect } from "react";
import { Box, Grid, Typography } from "@mui/material";
import Button from '@mui/material/Button';
import Modal from "../Modal";
import PrintIcon from '@mui/icons-material/Print';
import { CONFIG } from "../../Config";


const View194N = ({ open, handleClose, profileData, print, printElection }) => {

    return (
        <>
            <Modal open={open} title="View 194N" handleClose={handleClose} className="dialogStyle" screenFull={true} >
                <Grid rowSpacing={1} container className="padding-20" >
                    <Grid item xs={12} className="flex justifyC-end" >
                        <Button variant="contained" onClick={print} endIcon={<PrintIcon variant="btnIcon" />}>Print</Button>
                    </Grid>
                    <div className={printElection ? "printOnly" : ""}>
                        <Grid item xs={12} className="text-center" >
                            <img width="180px" height="auto" src={CONFIG.LOGO} />

                        </Grid>
                        <Grid item xs={12} className="padding-20" >
                            <table className="width-100p border-collapse border-none" >
                                <tbody><tr>
                                    <td > <Typography variant="print">To,</Typography></td>
                                </tr>
                                    <tr>
                                        <td> <Typography variant="print">BRANCH MANAGER,</Typography></td>
                                    </tr>
                                    <tr>
                                        <td > <Typography variant="print">BANK NAME:</Typography></td>

                                    </tr>

                                    <tr>
                                        <td > <Typography variant="print">BANK ADDRESS:</Typography></td>

                                    </tr>
                                </tbody></table>

                            <table >

                            </table>

                            <Typography variant="print">Subject: Business Correspondent Agent exempt from TDS for Cash withdrawal as per Income Tax Act Sec 194N(iii)</Typography>
                            <Typography variant="print">Dear Sir/Madam,</Typography>
                            <Typography variant="print">This is to bring to your kind attention upon a new Pursuant to Section U/s 194N (iii) of the Income-tax Act,1961
                                        (through the Finance (No.2)Act,2019), from September 1,2019 onwards, to provide for levy of tax deduction at
                                        source (TDS) @2% on cash payments in excess of Rupees Twenty Lakhs or Rupees one crore as the case may be,
                                        in aggregate made during the previous year, by a banking company or cooperative bank or post office, to any
                                        person from one or more accounts maintained with it by the recipient. However, the provision of this section will
                                    not apply to any Business Correspondent of a Banking Company.</Typography>

                            <Typography variant="print">In this connection, please note that only the amount settled by us from our Corporate BC Settlement Account
                                                            [Instant Mudra Technologies Private Limited] shall be exempt from TDS deduction u/s 194N (iii) of Income Tax
                                                            Act, 1961 (through the Finance (No.2) Act, 2019), and any additional amount withdrawn by Business
                                                       Correspondent Agent shall attract the said Income Tax provision for TDS deduction.</Typography>

                            <Typography variant="print">Further, please note that “INSTANT MUDRA TECHNOLOGIES PRIVATE LIMITED” is a channel partner of “BANK OF
                                                            INDIA (executed date 5 Feb 2020)” and facilitates to carry out various Banking and Financial Services. The
                                                            Account is maintained by Business Correspondent Agent with your branch for managing cash flows for Business
                                                            Correspondence activities. Please find here-in-below the details of Business Correspondent Agent working for
                                                            “INSTANT MUDRA TECHNOLOGIES PRIVATE LIMITED” which has an arrangement with BANK OF INDIA (A/c No.
                                012320110000548) as Corporate Business Correspondent.</Typography>

                            <table className="width-100p border-collapse border-none" >
                                <tbody><tr>
                                    <td > <Typography variant="print">Business Correspondent Agent Details:</Typography></td>

                                </tr>


                                    <tr>
                                        <td > <Typography variant="print">NAME: {profileData.full_name}</Typography></td>

                                    </tr>
                                    <tr>
                                        <td > <Typography variant="print">BC CODE: {profileData.guid}</Typography></td>

                                    </tr>
                                    <tr><td > <Typography variant="print">PAN NUMBER: {profileData.pan}</Typography></td>

                                    </tr>
                                    <tr><td > <Typography variant="print">ACCOUNT NUMBER:</Typography> </td>

                                    </tr>
                                </tbody></table>
                            <Typography variant="print">Hence, we most humbly request before your good-self to extend your kind co-operation in this matter by not<br />
                                withholding any TDS for withdrawals performed by the above mentioned account holder.</Typography>
                            <Typography variant="customh4" >Yours sincerely</Typography>
                            <img src="https://beta.instantmudra.net/apps/beta/media/images/sign.jpg" width="170px" height="auto" ></img>
                            <Typography variant="customh4" >Mr. Sajjad Shaikh</Typography>
                            <Typography variant="customh4" >(Director)</Typography>
                            <Typography variant="customh4" className="text-center"  >Instant Mudra Technologies Private Limited</Typography>
                            <table className="width-100p border-none">
                                <tbody>
                                    <tr>
                                        <td  >
                                            <Typography variant="print"><b>Corporate Office-</b>
                                                - Building F,5Th Floor, Pudhari
                                               Bhavan, Plot No 29 To 32 And 36, 37 , Sec-30A ,
                                               Near Sanpada Railway Station, Sanpada , Navi
                                               Mumbai-400705
                                               INDIA
                                         <br />GSTN - 27AAFCI2936K1ZB</Typography></td>
                                        <td >
                                            <Typography variant="print"> <b>Registered Office-</b>
                                                G/40, Sej Plaza CHS Premises, Marve
                                                Road, Nr. Kapol Bank &amp; Nutan School, Malad-W, Mumbai-
                                        400064, INDIA<br />CIN - U7290MH2019PTC326135</Typography>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                        </Grid>
                    </div>
                </Grid>
            </Modal>

        </>

    )
}

export default View194N